import { NgModule } from '@angular/core';

import { SharedModule } from '@app/shared';
import { AboutMenuDropDownComponent } from './about-menu-drop-down/about-menu-drop-down.component';
import { DropMenuItemComponent } from './drop-menu-item/drop-menu-item.component';
import { MenuItemComponent } from './menu-item/menu-item.component';
import { ProjectsMenuDropDownComponent } from './projects-menu-drop-down/projects-menu-drop-down.component';
import { ReportsMenuDropDownComponent } from './reports-menu-drop-down/reports-menu-drop-down.component';
import { UserManagementMenuDropDownComponent } from './user-management-menu-drop-down/user-management-menu-drop-down.component';
import { SideMenuComponent } from './side-menu.component';

@NgModule({
    imports: [SharedModule],
    declarations: [
        AboutMenuDropDownComponent,
        DropMenuItemComponent,
        MenuItemComponent,
        ProjectsMenuDropDownComponent,
        ReportsMenuDropDownComponent,
        UserManagementMenuDropDownComponent,
        SideMenuComponent
    ],
    entryComponents: [SideMenuComponent],
    exports: [SideMenuComponent]
})
export class SideMenuModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/side-menu/side-menu.module.ts